export const CREATE_ORDER = 'order/createOrder';
export const CREATE_ORDER_SUCCESS = 'order/createOrderSuccess';

export const CREATE_FREE_CLASS_ORDER = 'order/createFreeClassOrder';
export const CREATE_FREE_CLASS_ORDER_SUCCESS = 'order/createFreeClassOrderSuccess';
export const CREATE_FREE_CLASS_ORDER_ERROR = 'order/createFreeClassOrderError';
export const CREATE_FREE_CLASS_ORDER_NETWORK_ERROR = 'order/createFreeClassOrderNetworkError';

export const RESET_ORDER = 'order/resetOrder';
